import { createApp } from "vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import i18n from "./language/index";
import VueMatomo from "vue-matomo";
import vuetify from "@/plugins/vuetify";
import ApiClientService from "./services/api/ApiClientService";
import FormatService from "@/services/FormatService";

import "@mdi/font/css/materialdesignicons.css";
import App from "./App.vue";

/* Extend the window object to access lodash everywhere with _. instead of this._. */
window._ = require("lodash");

/* Set API Client */
window.ApiClient = ApiClientService;

/* Initialize Matomo queue */
window._paq = window._paq || [];

const app = createApp(App);

app.config.globalProperties.$axios = axios;

app.config.globalProperties.$filters = {
  currency(number, currency, locale) {
    return FormatService.currency(number, currency, locale);
  },
  date(date, dateStyle, locale) {
    if (!_.isNil(date)) {
      return FormatService.date(date, dateStyle, locale);
    }
    return date;
  },
  time(time, timeStyle, locale) {
    return FormatService.time(time, timeStyle, locale);
  },
};

app.use(VueMatomo, {
  host: process.env.VUE_APP_MATOMO_HOST,
  siteId: process.env.VUE_APP_MATOMO_SITE_ID,
  enableLinkTracking: true,
  router,
  requireConsent: true,
});

app.use(store);
app.use(router);
app.use(i18n);
app.use(vuetify);

app.mount("#app");
